export default "__VITE_ASSET__DsBIh83I__"